import React from 'react';
import Svg from "../Svg";

const TrackTypeGreenIcon = props => (
   <Svg width="30px" height="30px" viewBox={"30 30"}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
         <g id="MapStatus-06-12--map" transform="translate(-25.000000, -502.000000)">
            <g>
               <g transform="translate(24.000000, 453.000000)">
                  <g transform="translate(1.000000, 49.000000)">
                     <g>
                        <circle id="Oval" fill="#C8E6C9" fillRule="evenodd" cx="15" cy="15" r="15"/>
                        <circle id="Oval-Copy-3" fill="#4CAF50" fillRule="evenodd" cx="15" cy="15" r="11.6666667"/>
                        <text id="7D" fontFamily="MapFont, Open Sans" fontSize="14" fontWeight="normal"
                              fill="#FFFFFF">
                           <tspan x="7.27311198" y="19.0833333">7D</tspan>
                        </text>
                     </g>
                  </g>
               </g>
            </g>
         </g>
      </g>
   </Svg>
);

export default TrackTypeGreenIcon;
